module.exports = {"username":"demo.pemkab.sidoarjo","id":"5","group":"pemda","status":"enabled","detil":{"nama":"Demo Pemkab Sidoarjo","nip":"333333333333333333","provinsi_id":"11","provinsi":"Jawa Timur","kabupaten_id":"136","kabupaten":"Kabupaten Sidoarjo","kecamatan_id":null,"kecamatan":null,"kelurahan_id":null,"kelurahan":null,"kantor":"Kabupaten Sidoarjo","kantor_id":"136","kantor_level":"kabupaten"},"roleInfo":{"siroleg":[{"role":"siroleg.pemda.polpp","role_name":"Polpp","name":"siroleg","domains":"siroleg.beacukai.go.id","description":"Siroleg","icon":null}]}}


//////////////////
// WEBPACK FOOTER
// ./src/router/fake_tokens/token_polpp.json
// module id = ghG6
// module chunks = 10